import React from 'react'
import { SearchNormal1 } from 'iconsax-react'
import { Link } from 'react-router-dom'
import recentImg from '../../assets/img/recent1.png'
import CTAButton from '../../components/CTA/CTAButton'
import { Helmet } from "react-helmet-async";
function PopularStories() {

    const recentStories = [
        {
            id: 1,
            image: recentImg,
            title: "The Best Ways to Use the Internet",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse dapibus, enim sit amet pretium cursus, orci arcu blandit nisi, eu vestibulum turpis est eleifend eros.",
        },
        {
            id: 2,
            image: recentImg,
            title: "The Best Ways to Use the Internet",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse dapibus, enim sit amet pretium cursus, orci arcu blandit nisi, eu vestibulum turpis est eleifend eros.",
        },
        {
            id: 3,
            image: recentImg,
            title: "The Best Ways to Use the Internet",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse dapibus, enim sit amet pretium cursus, orci arcu blandit nisi, eu vestibulum turpis est eleifend eros.",
        },
        {
            id: 4,
            image: recentImg,
            title: "The Best Ways to Use the Internet",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse dapibus, enim sit amet pretium cursus, orci arcu blandit nisi, eu vestibulum turpis est eleifend eros.",
        },

    ]
    return (
        <>
           <Helmet>
                <title>Popular Stories</title>
           </Helmet>
            <section className='breadcrumb__section bg-overlay '>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'> Cardplot News </h3>
                                <p className='breadcrumb__text__content color__blue size_pricing'>
                                    Latest Stories on Cardplot
                                </p>
                            </div>
                            <div className="position-relative my-3">
                                <form className="d-flex align-items-center rounded-pill border px-3 py-1 bg-white mx-auto" style={{ maxWidth: "500px" }}>
                                    <SearchNormal1 className="me-2" color="#6c757d" />
                                    <input type="search" name="search" placeholder="Search for articles" className="form-control border-0 shadow-none" style={{ flex: 1 }} />
                                    <button type="submit" className="btn btn-dark btn-sm rounded-pill px-3" style={{ backgroundColor: "#2A0A7D"}}> Search </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__category__container pt-5 pb-5'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center '>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Accounts
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Virtual Cards
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    New Ghanian Tax Policy
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Malawian currency surge
                                </Link>
                            </div>
                        </div>
                        <div className='col-6 col-lg-2 col-md-12 col-sm-6 mb-4 mb-lg-0'>
                            <div className='blog__category__item'>
                                <Link to='/' className='blog__category__link'>
                                    Business Accounts
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='blog__popular__stories__container padding__tb'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='blog__popular__stories__title'>
                                <h2>Popular Stories</h2>
                            </div>
                        </div>
                    </div>
                    {recentStories.map((recent, index) => (
                        <div key={index} className="blog__popular__stories__item" style={{ paddingTop:'70px',}}>
                            <div className="blog__popular__stories__item__img">
                                <img src={recent.image} alt={`blog-${index + 1}`} className="img-fluid" />
                            </div>
                            <div className="blog__popular__stories__item__text">
                                <h3>{recent.title}</h3>
                                <p>{recent.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <CTAButton />
        </>
    )
}

export default PopularStories